/* eslint-disable no-use-before-define */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

//Dirigo Custom Functions
import { handleResponseError } from '@src/utility/Utils'

// ** Axios Imports
import axios from 'axios'
import { BackendUrl } from '@src/BackendUrl'


// NEW DIRIGO WAY TO FETCH DATA 
export const fetchEvents = createAsyncThunk('appCalendar/fetchEvents', async settings => {

  // NEW ENDPOINT (JUNE 2023)
  try {
    const businessUnit = settings?.businessUnit?.value
    const orgUnit = settings?.orgUnit?.value
    const workCenter = settings?.workCenter?.value
    const erganiFlag = settings?.showErganiData
    const month = settings?.month
    const year = settings?.year

    // Data from local storage
    const selectedHotel = JSON.parse(localStorage.getItem('selectedHotel'))
    const token = localStorage.getItem('accessToken')
    
    const calendarData = await axios.post(`${BackendUrl()}/stafftimer/calendarEventsVersion4/`, {token, selectedHotel, businessUnit, orgUnit, workCenter, month, year, erganiFlag})
    //console.log('Calendar Events Data:', calendarData.data)

    return calendarData.data

  } catch (error) {  //Error handling
    const errMessage = handleResponseError(error)
    //console.log(errMessage)
    return {
      //resources: [], //We set an empty array for the resources if case of error for the view to handle it and show the errorMessage
      errorMessage: errMessage
    }
  }  
})

/// DEFAULT OLD WAY TO FETCH DATA
// export const fetchEvents = createAsyncThunk('appCalendar/fetchEvents', async calendars => {
//   const response = await axios.get('/apps/calendar/events', { calendars })
//   return response.data
// })

// NEW DIRIGO WAY TO FILTER DATA (february 2024)
export const updateDepartments_ProgramTypeFilter = createAsyncThunk('appCalendar/updateDepartmentsFilter', async calendarData => {

  // Get selected depart_g's and departments
  const selectedDepartGs = calendarData.selectedDepartGList
  const selectedDepartments = calendarData.selectedDepartList
  const programTypes = calendarData.programType

  // We use initialResources to apply our filters
  const initialResources = calendarData.store.initialResources

  let filteredResources = []
  if (selectedDepartGs.length === 0 && selectedDepartments.length === 0) { 
    //console.log('NO DEPART_G & DEPARTMENT FILTERS')
    filteredResources = initialResources

  } else if (selectedDepartGs.length !== 0 && selectedDepartments.length === 0) { 
    //console.log('DEPART_G FILTER ONLY')
    filteredResources = initialResources.filter(resource => selectedDepartGs.some(departG => departG.value === resource.building_Group_Id))

  } else if (selectedDepartGs.length === 0 && selectedDepartments.length !== 0) { 
    //console.log('DEPARTMENT FILTER ONLY')
    filteredResources = initialResources.filter(resource => selectedDepartments.some(department => department.value === resource.building_Id))

  } else if (selectedDepartGs.length !== 0 && selectedDepartments.length !== 0) { 
    //console.log('DEPART_G & DEPARTMENT FILTERS')
    filteredResources = initialResources.filter(resource => selectedDepartments.some(department => department.value === resource.building_Id))
      //selectedDepartGs.some(departG => departG.value === resource.building_Group_Id) &&
  }

  if (programTypes && programTypes.length !== 0 && programTypes.length !== 2) { // Program Type (Fixed, Rolling) Filter
    filteredResources = filteredResources.filter(resource => programTypes.some(type => type.value === resource.hasFixedWorkHours))
  }

  // Return the filtered resources for the calendar
  return filteredResources
})

//Den xrisimopoieitai pia apo ton kwdika!!!
export const addEvent = createAsyncThunk('appCalendar/addEvent', async (event, { dispatch, getState }) => {
  await axios.post('/apps/calendar/add-event', { event })
  await dispatch(fetchEvents(getState().calendar.selectedCalendars))
  return event
})

//Den xrisimopoieitai pia apo ton kwdika!!!
export const updateEvent = createAsyncThunk('appCalendar/updateEvent', async (event, { dispatch, getState }) => {
  console.log('SELECTED EVENT TO UPDATE (store.js)', event)
  await axios.post('/apps/calendar/update-event', { event })
  await dispatch(fetchEvents(getState().calendar.selectedCalendars))
  return event
})

//Den xrisimopoieitai pia apo ton kwdika!!!
export const removeEvent = createAsyncThunk('appCalendar/removeEvent', async id => {
  await axios.delete('/apps/calendar/remove-event', { id })
  return id
})

//Den xrisimopoieitai pia apo ton kwdika!!!
export const updateFilter = createAsyncThunk('appCalendar/updateFilter', async (filter, { dispatch, getState }) => {
  if (getState().calendar.selectedCalendars.includes(filter)) {
    await dispatch(fetchEvents(getState().calendar.selectedCalendars.filter(i => i !== filter)))
  } else {
    await dispatch(fetchEvents([...getState().calendar.selectedCalendars, filter]))
  }
  return filter
})

//Den xrisimopoieitai pia apo ton kwdika!!!
export const updateAllFilters = createAsyncThunk('appCalendar/updateAllFilters', async (value, { dispatch }) => {
  if (value === true) {
    await dispatch(fetchEvents(['Personal', 'Business', 'Family', 'Holiday', 'ETC']))
  } else {
    await dispatch(fetchEvents([]))
  }
  return value
})

export const appCalendarSlice = createSlice({
  name: 'appCalendar',
  initialState: {
    success: false,            //**-* DIRIGO CUSTOM DATA ADDED!!!
    events: [], // All events
    displayEvents: [],  // Events Displayed on Calendar
    resources: [],
    initialResources: [],      //**-* DIRIGO CUSTOM DATA ADDED!!!
    employeeList: [],          //**-* DIRIGO CUSTOM DATA ADDED!!!
    branchList: [],            //**-* DIRIGO CUSTOM DATA ADDED!!!
    departmentList: [],        //**-* DIRIGO CUSTOM DATA ADDED!!!
    workCenterList: [],        //**-* DIRIGO CUSTOM DATA ADDED!!!
    businessUnitList: [],      //**-* DIRIGO CUSTOM DATA ADDED!!!
    selectedBusAndOrgUnit: {}, //**-* DIRIGO CUSTOM DATA ADDED!!!
    selectedEvent: {},
    //selectedCalendars: ['Personal', 'Business', 'Family', 'Holiday', 'ETC']
    selectedCalendars: ['3000'], // does it do anything?!?
    showOvertimes: true
  },
  reducers: {
    selectEvent: (state, action) => {
      state.selectedEvent = action.payload
    },
    toggleShowOvertimes: (state) => {
      state.showOvertimes = !state.showOvertimes
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchEvents.fulfilled, (state, action) => {

        //console.log('BUILDER CASE (events,resources) at store/index.js:', state, action)
        if (!action.payload?.errorMessage) {
          state.success = action.payload.success
          state.events = action.payload.events
          state.displayEvents = action.payload.events.filter(event => !event.erganiShift || (event.erganiShift && event.typeOfShift === "Overtime"))
          state.resources = action.payload.resources
          state.initialResources = action.payload.resources  // *** We keep the list of initial resources to apply filters on frontend!!!
          state.employeeList = action.payload.employeeList
          state.branchList = action.payload.branchList
          state.departmentList = action.payload.departmentList
          state.workCenterList = action.payload.workCenterList
          state.businessUnitList = action.payload.businessUnitList
          state.selectedBusAndOrgUnit = action.payload.selectedBusAndOrgUnit
          state.error = undefined
        } else {
          state.error = action.payload?.errorMessage
        }
      })

      .addCase(updateDepartments_ProgramTypeFilter.fulfilled, (state, action) => {
        //console.log('FILTER CASE updateDepartments_ProgramTypeFilter', state, action)
        state.resources = action.payload
      })

      .addCase(updateFilter.fulfilled, (state, action) => {
        if (state.selectedCalendars.includes(action.payload)) {
          state.selectedCalendars.splice(state.selectedCalendars.indexOf(action.payload), 1)
        } else {
          state.selectedCalendars.push(action.payload)
        }
      })
      .addCase(updateAllFilters.fulfilled, (state, action) => {
        const value = action.payload
        let selected = []
        if (value === true) {
          selected = ['Personal', 'Business', 'Family', 'Holiday', 'ETC']
        } else {
          selected = []
        }
        state.selectedCalendars = selected
      })
  }
})

export const { selectEvent, toggleShowOvertimes } = appCalendarSlice.actions

export default appCalendarSlice.reducer
